import { useAutoAnimate } from "@formkit/auto-animate/react";
import { useInfiniteQuery } from "@tanstack/react-query";
import InfiniteScroll from "react-infinite-scroll-component";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { getExploreMovie, getExploreTV } from "../../services/explore";
import FilmCardItem from "../Common/FilmCardItem";
import Skeleton from "../Common/Skeleton";

const ExploreFilmResult = ({ pages, genresList }) => {
  const [parent] = useAutoAnimate();

  return (
    <ul
      ref={parent}
      className="flex flex-wrap items-start gap-x-[25px] gap-y-10 pl-2 pt-2 overflow-hidden"
    >
      {pages &&
        pages.length > 0 &&
        pages.map((page) =>
          page.results.map((item) => (
            <li key={item.id}>
              <FilmCardItem item={item} genresList={genresList} />
            </li>
          ))
        )}
      {!pages &&
        [...new Array(15)].map((_, index) => (
          <li key={index}>
            <Skeleton className="!w-[200px] !h-[300px] shadow-sm rounded-md overflow-hidden" />
          </li>
        ))}
    </ul>
  );
};

const ExploreResult = ({ currentTab, config, moviesGenres, tvGenres }) => {
  const {
    data: movies,
    error: errorMovies,
    fetchNextPage: fetchNextPageMovie,
    hasNextPage: hasNextPageMovie,
  } = useInfiniteQuery(
    ["explore-result-movie", config],
    ({ pageParam = 1 }) => getExploreMovie(pageParam, config),
    {
      getNextPageParam: (lastPage) =>
        lastPage.page + 1 <= lastPage.total_pages
          ? lastPage.page + 1
          : undefined,
    }
  );

  const {
    data: tvs,
    error: errorTvs,
    fetchNextPage: fetchNextPageTv,
    hasNextPage: hasNextPageTv,
  } = useInfiniteQuery(
    ["explore-result-tv", config],
    ({ pageParam = 1, queryKey }) => getExploreTV(pageParam, queryKey[1]),
    {
      getNextPageParam: (lastPage) =>
        lastPage.page + 1 <= lastPage.total_pages
          ? lastPage.page + 1
          : undefined,
    }
  );

  if (errorMovies) return <div>ERROR: {errorMovies.message}</div>;
  if (errorTvs) return <div>ERROR: {errorTvs.message}</div>;

  return (
    <>
      {currentTab === "movie" && (
        <InfiniteScroll
          dataLength={movies?.pages.length || 0}
          next={() => fetchNextPageMovie()}
          hasMore={Boolean(hasNextPageMovie)}
          loader={<div className="text-center m-3">Loading...</div>}
          endMessage={<div>No more results</div>}
        >
          <ExploreFilmResult pages={movies?.pages} genresList={moviesGenres} />
        </InfiniteScroll>
      )}

      {currentTab === "tv" && (
        <InfiniteScroll
          dataLength={tvs?.pages.length || 0}
          next={() => fetchNextPageTv()}
          hasMore={Boolean(hasNextPageTv)}
          loader={<div>Loading...</div>}
          endMessage={
            <div className="flex flex-col items-center mb-12 mt-5">
              <LazyLoadImage
                src="/empty.svg"
                alt=""
                effect="opacity"
                className="w-[10vw] min-w-[250px]"
              />
              <p className="text-white text-xl md:text-2xl mt-10">
                No more results
              </p>
            </div>
          }
        >
          <ExploreFilmResult pages={tvs?.pages} genresList={tvGenres} />
        </InfiniteScroll>
      )}
    </>
  );
};

export default ExploreResult;
